module.exports = __webpack_public_path__ + "static/img/limit_white_05.45382d65.svg";